module.exports = {
  'live-pulse-light': 'live-pulse-light 1s linear infinite',
  'live-pulse-dark': 'live-pulse-dark 1s linear infinite',
  'marquee-first-part': 'marquee-first-part 5s linear infinite',
  'marquee-second-part': 'marquee-second-part 5s linear infinite',
  'pulse-first-waves-light':
    'pulse-first-waves-light 3.5s ease-in-out infinite',
  'pulse-first-waves-dark': 'pulse-first-waves-dark 3.5s ease-in-out infinite',
  'pulse-second-waves-light':
    'pulse-second-waves-light 3.5s ease-in-out infinite',
  'pulse-second-waves-dark':
    'pulse-second-waves-dark 3.5s ease-in-out infinite',
  blink: 'blink 0.45s infinite',
  spin: 'spin 1.4s linear infinite',
  spinnerStroke: 'spinnerStroke 1.4s ease-in-out infinite'
};
